import script from "./Overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Overview.vue?vue&type=script&setup=true&lang=ts"

import "./Overview.vue?vue&type=style&index=0&id=38ebb9d3&lang=css"

const __exports__ = script;

export default __exports__